import Navbar from "../components/Navbar";
import ReactMarkdown from "react-markdown";
import React, { useEffect } from "react";
import useState from "react-usestateref";

function Impressum() {
  const [markdown, setMarkdown] = useState("");

  const loadDoc = async (file) => {
    const res = await fetch(`/docs/${file}`);
    const text = await res.text();
    setMarkdown(text);
  };

  // load default tab
  useEffect(() => {
    loadDoc("legal_notice.md");
  }, []);

  return (
    <div className="main-container">

      <div style={{ display: "flex", height: "100%" }}>

        {/* LEFT SIDEBAR */}
        <div
          style={{
            width: "120px",
            borderRight: "1px solid #e5e7eb",
            padding: "10px",
          }}
        >
        </div>

        {/* RIGHT CONTENT */}
        <div
          style={{
            flex: 1,
            padding: "20px",
            overflowY: "auto",
          }}
        >
          <ReactMarkdown
            components={{
              img: ({ node, ...props }) => (
                <img
                  src={`/docs/${props.src}`}   // 👈 important fix
                  alt={props.alt}
                  style={{
                    maxWidth: "300px",     // ✅ controls size
                    width: "60%",         // responsive
                    height: "auto",
                    borderRadius: "8px",
                    margin: "12px 0",
                    display: "block",
                  }}
                />
              ),
            }}
          >
            {markdown}
          </ReactMarkdown>
          <br></br>
          <br></br>
        </div>

      </div>
    </div>
  );
}

export default Impressum;